import { configConstants } from "redux/constants";

export function getLegalChecklistReducer(state = {}, action) {
  switch (action.type) {
    case configConstants.GET_LEGAL_CHECKLIST_REQUEST:
      return { loading: true };
    case configConstants.GET_LEGAL_CHECKLIST_SUCCESS:
      return { propertyLegals: action.payload };
    case configConstants.GET_LEGAL_CHECKLIST_FAILURE:
      return { loading: false };
    default:
      return {};
  }
}
